<template>
<div class="chapter">
<div class="inner_page">
<div class="Basic-Text-Frame" id="_idContainer000">
<p class="tp1">THE VERDICT</p>
<p class="tp2">ON EACH MAN DEAD</p>
<p class="tp2">DAVID</p>
<p class="tp3">WHELLAMS</p>
<p class="tp4">A PETER CAMMON MYSTERY</p>
<p class="tp4">ECW Press</p>
</div>
<div class="image"><p class="image-center">
<img alt="" src="image/dude.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// verdictoneachmandead.vue?85e39406